/**
 * Réduit une photo avant de la garder sur le téléphone : 2 000 pixels de côté au maximum, JPEG.
 * Une photo d'iPhone passe ainsi d'environ 3 à 5 Mo à 0,5 Mo, sans perte visible pour un relevé.
 */
export async function preparerPhoto(fichier: File): Promise<Blob> {
  try {
    const image = await createImageBitmap(fichier);
    const echelle = Math.min(1, 2000 / Math.max(image.width, image.height));
    const toile = document.createElement("canvas");
    toile.width = Math.round(image.width * echelle);
    toile.height = Math.round(image.height * echelle);
    const contexte = toile.getContext("2d");
    if (!contexte) return fichier;
    contexte.drawImage(image, 0, 0, toile.width, toile.height);
    image.close();
    return await new Promise<Blob>((resoudre) =>
      toile.toBlob((blob) => resoudre(blob ?? fichier), "image/jpeg", 0.82),
    );
  } catch {
    return fichier; // format non lisible par le navigateur : on garde l'original
  }
}
